/**
 * Smooth scrolling for in-page anchor links (`<a href="#section">`).
 */
export function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            // A bare "#" is swallowed too (no jump to the top), as before.
            e.preventDefault();

            const href = this.getAttribute('href');
            if (href === '#') return;

            // getElementById instead of querySelector: an id that starts with
            // a digit, or a hash-router link, is not a valid CSS selector and
            // used to throw here; a missing target used to throw too.
            const target = document.getElementById(decodeURIComponent(href.slice(1)));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}
